import _classPrivateFieldInitSpec from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldInitSpec.js";
import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _classPrivateFieldGet from "/var/www/html/node_modules/@babel/runtime/helpers/esm/classPrivateFieldGet2.js";
import "core-js/modules/esnext.iterator.map.js";
import JsonMappedModel from "../helpers/JsonMappedModel";
import User from "../user/User";
import InvoiceOrderCollection from "./InvoiceOrderCollection";
import Role from "../role/Role";
import SubscriptionPlan from "../SubscriptionPlan/SubscriptionPlan";
import InvoiceCustomData from "./InvoiceCustomData";
var _attributes = /*#__PURE__*/new WeakMap();
export default class Invoice extends JsonMappedModel {
  constructor(data) {
    super(data);
    _classPrivateFieldInitSpec(this, _attributes, {
      [Invoice.id_attribute_name]: null,
      [Invoice.generated_by_attribute_name]: User,
      [Invoice.invoice_payment_id_attribute_name]: null,
      [Invoice.invoice_payment_method_attribute_name]: null,
      [Invoice.invoice_payment_status_attribute_name]: null,
      [Invoice.invoice_payment_type_attribute_name]: null,
      [Invoice.invoice_total_attribute_name]: null,
      [Invoice.created_at_attribute_name]: null,
      [Invoice.issuer_id_attribute_name]: null,
      [Invoice.invoice_invoice_orders_attribute_name]: InvoiceOrderCollection,
      [Invoice.invoice_advertiser_total_attribute_name]: null,
      [Invoice.network_expenses_attribute_name]: null,
      [Invoice.paid_at_attribute_name]: null,
      [Invoice.remitted_party_attribute_name]: User,
      [Invoice.issued_for_attribute_name]: User,
      [Invoice.referrer_commission_attribute_name]: null,
      [Invoice.due_at_attribute_name]: null,
      [Invoice.subscription_plan_attribute_name]: SubscriptionPlan,
      [Invoice.custom_data_attribute_name]: InvoiceCustomData
    });
    this.map(data, _classPrivateFieldGet(_attributes, this));
  }
  static getIdAttributeName() {
    return this.id_attribute_name;
  }
  static getDueAtAttributeName() {
    return this.due_at_attribute_name;
  }
  static getPaidAtAttributeName() {
    return this.paid_at_attribute_name;
  }
  static getCreatedAtAttributeName() {
    return this.created_at_attribute_name;
  }
  static getPaymentIdAttributeName() {
    return this.invoice_payment_id_attribute_name;
  }
  static getSubscriptionPlanAttributeName() {
    return this.subscription_plan_attribute_name;
  }
  static getCustomDataAttributeName() {
    return this.custom_data_attribute_name;
  }
  static getIssuedForAttributeName() {
    return this.issued_for_attribute_name;
  }
  static getGeneratedByAttributeName() {
    return this.generated_by_attribute_name;
  }
  static getPaymentMethodAttributeName() {
    return this.invoice_payment_method_attribute_name;
  }
  static getTotalAttributeName() {
    return this.invoice_total_attribute_name;
  }
  static getPaymentStatusAttributeName() {
    return this.invoice_payment_status_attribute_name;
  }
  getPaymentMethod() {
    return this.getAttribute(Invoice.getPaymentMethodAttributeName());
  }
  setPaymentMethod(paymentMethod) {
    return this.setAttribute(Invoice.getPaymentMethodAttributeName(), paymentMethod);
  }
  getGeneratedBy() {
    return this.getAttribute(Invoice.getGeneratedByAttributeName());
  }
  getGeneratedByName() {
    const generatedBy = this.getGeneratedBy();
    return generatedBy instanceof User ? generatedBy.getUserName() : null;
  }
  getPaymentId() {
    return this.getAttribute(Invoice.getPaymentIdAttributeName());
  }
  setPaymentId(id) {
    return this.setAttribute(Invoice.getPaymentIdAttributeName(), id);
  }
  getPaidAt() {
    return this.getAttribute(Invoice.getPaidAtAttributeName());
  }
  getSubscriptionPlan() {
    return this.getAttribute(Invoice.getSubscriptionPlanAttributeName());
  }
  getDueAtAttributeName() {
    return this.getAttribute(Invoice.getDueAtAttributeName());
  }
  getIssuedForRole() {
    let issuedFor = this.getIssuedFor();
    return issuedFor instanceof User ? issuedFor.getRole() : null;
  }
  getIssuedForRoleName() {
    let role = this.getIssuedForRole();
    return role instanceof Role ? role.getName() : null;
  }
  isIssuedForWarehouse() {
    return this.getIssuedForRoleName() === Role.WAREHOUSE_ROLE;
  }
  getPaymentType() {
    return this.getAttribute(Invoice.invoice_payment_type_attribute_name);
  }
  isExpenses() {
    return this.getPaymentType() === Invoice.EXPENSES_TYPE;
  }
  getPaymentStatus() {
    return this.getAttribute(Invoice.invoice_payment_status_attribute_name);
  }
  isPaid() {
    return this.getPaymentStatus() === Invoice.PAID_STATUS;
  }
  getReferrerCommission() {
    return this.getAttribute(Invoice.referrer_commission_attribute_name);
  }
  getCreatedAt() {
    return this.getAttribute(Invoice.created_at_attribute_name);
  }
  getTotal() {
    return this.getAttribute(Invoice.invoice_total_attribute_name);
  }
  getGeneratedFor() {
    return this.getAttribute(Invoice.issued_for_attribute_name);
  }
  getIssuedFor() {
    return this.getAttribute(Invoice.issued_for_attribute_name);
  }
  getIssuedForName() {
    let issuedFor = this.getIssuedFor();
    return issuedFor instanceof User ? issuedFor.getName() : null;
  }
  getGeneratedForReferrer() {
    let generatedFor = this.getGeneratedFor();
    return generatedFor instanceof User ? generatedFor.getReferrer() : null;
  }
  getGeneratedForReferrerName() {
    let generatedForReferrer = this.getGeneratedForReferrer();
    return generatedForReferrer instanceof User ? generatedForReferrer.getName() : null;
  }
  getGeneratedForReferrerFullName() {
    let generatedForReferrer = this.getGeneratedForReferrer();
    return generatedForReferrer instanceof User ? generatedForReferrer.getFullName() : null;
  }
  getGeneratedForName() {
    let generatedFor = this.getGeneratedFor();
    return generatedFor instanceof User ? generatedFor.getName() : null;
  }
  getCustomData() {
    return this.getAttribute(Invoice.getCustomDataAttributeName());
  }
  static getPaidPartyBankDetails(invoice) {
    if (!(invoice instanceof Invoice)) {
      return null;
    }
    const issuedFor = invoice.getIssuedFor();
    return issuedFor instanceof User ? issuedFor.getBankDetails() : null;
  }
  static getPaidPartyPayoneerDetails(invoice) {
    if (!(invoice instanceof Invoice)) {
      return null;
    }
    const issuedFor = invoice.getIssuedFor();
    return issuedFor instanceof User ? issuedFor.getPayoneer() : null;
  }
  static getSelectedPaymentMethod(invoice, paymentMethod) {
    switch ((paymentMethod !== null && paymentMethod !== void 0 ? paymentMethod : invoice instanceof Invoice) ? invoice.getPaymentMethod() : null) {
      case Invoice.BANK_TRANSFER:
        return Invoice.getPaidPartyBankDetails(invoice);
      case Invoice.PAYONEER:
        return Invoice.getPaidPartyPayoneerDetails(invoice);
    }
  }
}
_defineProperty(Invoice, "PAID_STATUS", 'paid');
_defineProperty(Invoice, "PENDING_STATUS", 'pending');
_defineProperty(Invoice, "NOT_APPLICABLE_STATUS", 'n-a');
_defineProperty(Invoice, "BANK_TRANSFER", 'bank-transfer');
_defineProperty(Invoice, "PAYONEER", 'payoneer');
_defineProperty(Invoice, "REMITTANCE_TYPE", 'remittance');
_defineProperty(Invoice, "COMMISSION_TYPE", 'commission');
_defineProperty(Invoice, "PAYOUT_TYPE", 'payout');
_defineProperty(Invoice, "REFERRER_PAYOUT_TYPE", 'referrer_payout');
_defineProperty(Invoice, "SUBSCRIPTION_COMMISSION_TYPE", 'subscription_commission');
_defineProperty(Invoice, "id_attribute_name", 'invoice_id');
_defineProperty(Invoice, "generated_by_attribute_name", 'generated_by');
_defineProperty(Invoice, "invoice_payment_id_attribute_name", 'invoice_payment_id');
_defineProperty(Invoice, "invoice_payment_method_attribute_name", 'invoice_payment_method');
_defineProperty(Invoice, "invoice_payment_status_attribute_name", 'invoice_payment_status');
_defineProperty(Invoice, "invoice_payment_type_attribute_name", 'invoice_payment_type');
_defineProperty(Invoice, "invoice_total_attribute_name", 'invoice_total');
_defineProperty(Invoice, "created_at_attribute_name", 'created_at');
_defineProperty(Invoice, "issuer_id_attribute_name", 'issuer_id');
_defineProperty(Invoice, "invoice_invoice_orders_attribute_name", 'invoice_invoice_orders');
_defineProperty(Invoice, "invoice_advertiser_total_attribute_name", 'invoice_advertiser_total');
_defineProperty(Invoice, "network_expenses_attribute_name", 'network_expenses');
_defineProperty(Invoice, "paid_at_attribute_name", 'paid_at');
_defineProperty(Invoice, "remitted_party_attribute_name", 'remitted_party');
_defineProperty(Invoice, "issued_for_attribute_name", 'issued_for');
_defineProperty(Invoice, "referrer_commission_attribute_name", 'referrer_commission');
_defineProperty(Invoice, "due_at_attribute_name", 'due_at');
_defineProperty(Invoice, "subscription_plan_attribute_name", 'subscription_plan');
_defineProperty(Invoice, "custom_data_attribute_name", 'custom_data');